import { useEffect } from "react";
import axios from "axios";
import { useCruise } from "../context/CruiseContext";
import { getSessionId } from "../lib/session";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TAWK_SRC = process.env.REACT_APP_TAWK_SRC;

const CRUISE_LABELS = {
  "caribbean-2027": "The Getaway (2027 • Caribbean)",
  "europe-2027": "The Europe Experience (2027 • Europe)",
  "escape-2026": "The Escape (2026 • New Orleans)",
};
const labelFor = (id) => CRUISE_LABELS[id] || id || "Unknown";

// Share the visitor's current cruise + page with the Tawk agent panel.
const pushContext = (cruiseId) => {
  const api = window.Tawk_API;
  if (!api) return;
  const cruise = labelFor(cruiseId);
  const page = window.location.pathname;
  try {
    if (typeof api.setAttributes === "function") {
      api.setAttributes({ "Cruise": cruise, "Current Page": page }, () => {});
    }
    if (typeof api.addTags === "function") {
      api.addTags([cruise], () => {});
    }
  } catch (e) {
    /* ignore */
  }
};

// Loads the branded Tawk.to live-chat widget and pings our backend when a chat starts.
const TawkChat = () => {
  const { EVENT } = useCruise();

  // Keep the current cruise available to the (once-bound) Tawk callbacks, and
  // update the Tawk visitor context whenever the active cruise/page changes.
  useEffect(() => {
    window.__hhasCruise = EVENT.id;
    pushContext(EVENT.id);
  }, [EVENT.id]);

  useEffect(() => {
    if (!TAWK_SRC || window.__tawkLoaded) return;
    window.__tawkLoaded = true;
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    // Set the visitor's cruise/page as soon as the widget finishes loading,
    // and hide Tawk's own bubble so our AI assistant is the single launcher.
    window.Tawk_API.onLoad = () => {
      pushContext(window.__hhasCruise || EVENT.id);
      try { window.Tawk_API.hideWidget(); } catch (e) {}
    };
    // When the visitor finishes with the human chat, hide Tawk's bubble again
    // so only the AI "Ask AI" launcher remains on screen.
    const rehide = () => { try { window.Tawk_API.hideWidget(); } catch (e) {} };
    window.Tawk_API.onChatMinimized = rehide;
    window.Tawk_API.onChatWindowClosed = rehide;

    let notified = false;
    window.Tawk_API.onChatStarted = () => {
      pushContext(window.__hhasCruise || EVENT.id);
      if (notified) return;
      notified = true;
      axios
        .post(`${API}/chat/started`, {
          session_id: getSessionId(),
          cruise: window.__hhasCruise || EVENT.id,
          name: "",
        })
        .catch(() => {});
    };

    const s = document.createElement("script");
    s.async = true;
    s.src = TAWK_SRC;
    s.charset = "UTF-8";
    s.crossOrigin = "anonymous";
    document.body.appendChild(s);
  }, [EVENT.id]);

  return null;
};

export default TawkChat;
